export const PRODUCT_SELECTED = 'Product Selected';
export const CHECKOUT_COMPLETED = 'Checkout Completed';
export const TOGGLE_UPGRADE_MODAL = 'Toggle Upgrade Modal';